<template>
  <div class="mb-4">
    <label for="">{{ t('profile.username') }}</label>
    <input type="text" class="form-control" disabled v-model="user.username" autocomplete="off" >
  </div>
  <div class="mb-4">
    <label for="">{{ t('profile.balance') }}</label>
    <input type="text" class="form-control" disabled v-model="user.chip" autocomplete="off">
  </div>
  <div class="mb-4">
    <label for="">{{ t('profile.point') }}</label>
    <input type="text" class="form-control" disabled v-model="user.point" autocomplete="off">
  </div>
  <h3 class="block text-amber-500 text-3xl mb-2">{{ t('profile.changePassword') }}</h3>
  <form ref="form_changepass" @submit="changePassword" method="post">
    <div class="mb-4">
      <label for="">{{ t('profile.currentPassword') }}</label>
      <input type="password" class="form-control" name="password" v-model="password" autocomplete="off" :placeholder="t('profile.currentPassword') + ' (*)'" >
    </div>
    <div class="mb-4">
      <label for="">{{ t('profile.newPassword') }}</label>
      <input type="password" class="form-control" name="password_new" autocomplete="off" v-model="passwordNew" :placeholder="t('profile.newPassword') + ' (*)'" >
    </div>
    <div class="mb-4">
      <label for="">{{ t('profile.confirmPassword') }}</label>
      <input type="password" class="form-control" name="password_confirm" autocomplete="off" v-model="passwordConfirm" :placeholder="t('profile.confirmPassword') + ' (*)'" >
    </div>
    <div class="w-full flex items-center justify-center">
      <button class="btn btn-primary" type="submit">{{ t('common.submit') }}</button>
    </div>
  </form>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { proxy } = getCurrentInstance();

const user = computed(() => proxy.$store.state.user)
const password = ref('')
const passwordNew = ref('')
const passwordConfirm = ref('')

const getInfo = async () => {
  await proxy.$store.dispatch('fetchMyInfo')
}

const changePassword = async (e) => {
  e.preventDefault()
  await proxy.$store.dispatch('patchMyInfo', {
    password: password.value,
    passwordNew: passwordNew.value,
    successMessage: t('profile.passwordChanged')
  })
  password.value = passwordNew.value = passwordConfirm.value = ''
}

onMounted(() => {
  getInfo()
})
</script>

<style>
.form-control:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
}

.btn-primary {
  min-width: 120px;
}

@media (max-width: 768px) {
  .btn-primary {
    min-width: 100px;
  }
}
</style>
